import { useEffect, useState } from 'react';
import api from '@/lib/api';
import { PageHeader } from '@/components/ui-bits';
import { fmtRelative } from '@/lib/format';

export default function AuditLogsPage() {
  const [logs, setLogs] = useState([]);
  const [users, setUsers] = useState({});
  const load = async () => {
    const { data } = await api.get('/admin/audit-logs?limit=300');
    setLogs(data.logs);
  };
  useEffect(() => { load(); api.get('/admin/users').then((r) => setUsers(Object.fromEntries(r.data.users.map((u) => [u.id, u])))).catch(() => {}); }, []);
  return (
    <div>
      <PageHeader title="Auditoría" description="Historial completo de acciones en tu empresa." />
      <div className="surface">
        <table className="w-full text-sm">
          <thead><tr className="text-left text-xs text-muted-foreground border-b border-border"><th className="px-3 py-2">Cuando</th><th className="px-3 py-2">Acción</th><th className="px-3 py-2">Objeto</th><th className="px-3 py-2">Actor</th><th className="px-3 py-2">Detalles</th></tr></thead>
          <tbody>{logs.map((l) => (
            <tr key={l.id} data-testid="audit-row" className="h-10 border-b border-border/70 hover:bg-accent/60">
              <td className="px-3 text-xs text-muted-foreground">{fmtRelative(l.created_at)}</td>
              <td className="px-3"><span className="chip">{l.action}</span></td>
              <td className="px-3 text-xs">{l.target_type}{l.target_id ? ` · ${l.target_id.slice(0, 8)}…` : ''}</td>
              <td className="px-3 text-xs text-muted-foreground">{users[l.actor_id]?.name || users[l.actor_id]?.email || (l.actor_id ? 'externo' : 'sistema')}</td>
              <td className="px-3 text-xs font-mono text-muted-foreground truncate max-w-[400px]">{l.meta ? JSON.stringify(l.meta) : ''}</td>
            </tr>
          ))}{logs.length === 0 && <tr><td colSpan="5" className="text-center text-muted-foreground text-sm py-8">Sin eventos.</td></tr>}</tbody>
        </table>
      </div>
    </div>
  );
}
